// src/components/WhatsAppFloat.jsx
import { useState, useEffect, useRef } from 'react';

const WhatsAppFloat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const branches = [
    { city: "VIJAYAWADA", phone: "919490948081", label: "Main Branch" },
    { city: "KPHB HYDERABAD", phone: "918121222888", label: "JNTU / KPHB" },
    // { city: "AMEERPET", phone: "918121666111", label: "Ameerpet Branch" },
    { city: "NALLAGANDLA", phone: "919542027700", label: "BHEL / Nallagandla" }
  ];

  const defaultMessage = encodeURIComponent("Hello! I'd like to book an appointment.");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    /* 1. Added pointer-events-none here to let clicks pass through the container */
    <div 
      className="fixed bottom-[max(1.5rem,env(safe-area-inset-bottom))] right-[max(1.5rem,env(safe-area-inset-right))] z-[999] flex flex-col items-end pointer-events-none"
      ref={menuRef}
    >
      {/* WhatsApp Menu Box */}
      <div
        className={`mb-4 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden transition-all duration-300 origin-bottom-right
          /* 2. pointer-events-auto makes the menu clickable ONLY when isOpen is true */
          ${isOpen 
            ? 'opacity-100 scale-100 translate-y-0 visible pointer-events-auto' 
            : 'opacity-0 scale-90 translate-y-10 invisible pointer-events-none'
          }`}
      >
        <div className="bg-[#25D366] p-4 text-white">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
              <i className="fab fa-whatsapp text-2xl" />
            </div>
            <div>
              <h3 className="font-bold text-sm">Chat with us</h3>
              <p className="text-[10px] opacity-90 uppercase tracking-wider">Typically replies in minutes</p>
            </div>
          </div>
        </div>

        <div className="p-3 bg-gray-50 space-y-2">
          {branches.map((branch, index) => (
            <a
              key={index}
              href={`https://wa.me/${branch.phone}?text=${defaultMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-100 
                         hover:border-green-400 hover:shadow-md transition-all group"
            >
              <div>
                <div className="text-xs font-black text-blue-600 mb-0.5">{branch.city}</div>
                <div className="text-sm font-bold text-gray-800">{branch.label}</div>
              </div>
              <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center group-hover:bg-[#25D366] group-hover:text-white transition-colors">
                <i className="fab fa-whatsapp text-lg" />
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* Main Floating Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        /* 3. Added pointer-events-auto here so the button itself remains clickable */
        className={`relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16
                   rounded-full shadow-xl transition-all duration-500 pointer-events-auto
                   hover:scale-110 active:scale-95 focus:outline-none
                   ${isOpen ? 'bg-blue-600 rotate-[360deg]' : 'bg-[#25D366]'}`}
      >
        {!isOpen && (
          <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping pointer-events-none" />
        )}

        <div className="relative z-10">
          {isOpen ? (
            <i className="fas fa-times text-xl text-white" />
          ) : (
            <i className="fab fa-whatsapp text-3xl md:text-4xl text-white" />
          )}
        </div>
      </button>
      {/* Tooltip (Desktop Only) */}
      {!isOpen && (
        <div className="absolute right-20 bottom-4 hidden lg:block px-4 py-2 bg-blue-600 text-white text-xs font-bold rounded-lg shadow-lg whitespace-nowrap animate-bounce-horizontal">
          Book Appointment
          <div className="absolute top-1/2 -right-1 -translate-y-1/2 w-2 h-2 bg-blue-600 rotate-45" />
        </div>
      )}
    </div>
  );
};

export default WhatsAppFloat;